module.exports = __webpack_public_path__ + "static/img/qr.56d70c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qr.png
// module id = 13
// module chunks = 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44